export interface Experience {
  id: string;
  role: string;
  company: string;
  type: 'work' | 'founder' | 'partner';
  startDate: string;
  endDate: string | 'Actualmente';
  description: string[];
  descriptionEn?: string[];
  technologies?: string[];
}

export interface Education {
  id: string;
  title: string;
  titleEn?: string;
  institution: string;
  startDate: string;
  endDate: string;
  description?: string;
  descriptionEn?: string;
}

export const experience: Experience[] = [
  {
    id: 'hauslook',
    role: 'CTO & Tech Lead',
    company: 'HausLook',
    type: 'partner',
    startDate: 'Mayo 2025',
    endDate: 'Actualmente',
    description: [
      '<strong>Liderazgo tecnológico</strong> de una plataforma integral para diseño de baños, cocinas y exteriores que unifica proveedores y ofrece ambientes completos a clientes.',
      'Desarrollo <strong>full-stack</strong> con <strong>React</strong>, <strong>TypeScript</strong> y <strong>Supabase</strong> para gestión de base de datos y storage.',
      'Implementación de <strong>agentes de IA</strong> para automatización de gestión de datos y procesos.',
      'Desarrollo de <strong>backoffice corporativo</strong> desplegado en <strong>Netlify</strong>.',
      '<strong>Configurador 3D interactivo</strong> en <strong>Unity WebGL</strong> para personalización de productos.',
      'Pipeline de <strong>renderizado hiperrealista</strong> con <strong>3ds Max</strong> y <strong>V-Ray</strong> para visualización fotorrealista de ambientes.',
      'Integración de herramientas de <strong>desarrollo asistido por IA</strong> (<strong>Claude Code</strong>, <strong>Cursor</strong>).',
    ],
    descriptionEn: [
      '<strong>Technical leadership</strong> of an integral platform for bathroom, kitchen, and exterior design that unifies providers and offers complete environments to clients.',
      '<strong>Full-stack</strong> development with <strong>React</strong>, <strong>TypeScript</strong>, and <strong>Supabase</strong> for database and storage management.',
      'Implementation of <strong>AI agents</strong> for data management and process automation.',
      'Development of <strong>corporate backoffice</strong> deployed on <strong>Netlify</strong>.',
      '<strong>Interactive 3D configurator</strong> in <strong>Unity WebGL</strong> for product customization.',
      '<strong>Photorealistic rendering</strong> pipeline with <strong>3ds Max</strong> and <strong>V-Ray</strong> for lifelike environment visualization.',
      'Integration of <strong>AI-assisted development</strong> tools (<strong>Claude Code</strong>, <strong>Cursor</strong>).',
    ],
    technologies: [
      'React',
      'TypeScript',
      'Supabase',
      'Netlify',
      'Unity WebGL',
      '3ds Max',
      'V-Ray',
      'Claude Code',
      'Cursor AI',
      'AI Agents',
    ],
  },
  {
    id: 'lyceum-vr',
    role: 'CEO / CTO',
    company: 'Lyceum VR',
    type: 'founder',
    startDate: '2020',
    endDate: 'Actualmente',
    description: [
      '<strong>Fundador</strong> de Lyceum VR, empresa especializada en <strong>educación mediante Realidad Virtual</strong>.',
      'Desarrollo de productos propios como <strong>Popau</strong> (AR Trading Cards).',
      '<strong>Dirección técnica y estratégica</strong> de la empresa.',
      'Desarrollo de proyectos para <strong>clientes internacionales</strong>.',
    ],
    descriptionEn: [
      '<strong>Founder</strong> of Lyceum VR, a company specialized in <strong>Virtual Reality education</strong>.',
      'Development of proprietary products like <strong>Popau</strong> (AR Trading Cards).',
      '<strong>Technical and strategic leadership</strong> of the company.',
      'Project development for <strong>international clients</strong>.',
    ],
    technologies: ['Unity', 'C#', 'VR/AR', 'XR', 'HoloLens', 'Quest'],
  },
  {
    id: 'ct-ingenieros',
    role: 'Researcher and Developer (Simulation Software)',
    company: 'CT Ingenieros',
    type: 'work',
    startDate: '2019',
    endDate: '2020',
    description: [
      '<strong>I+D</strong>: Investigación, creación y desarrollo de <strong>software de simulación</strong> civil y militar.',
      'Motores: <strong>Unity3D</strong> y software militar privado.',
      '<strong>Supervisor</strong> de proyectos de grado y máster.',
    ],
    descriptionEn: [
      '<strong>R&D</strong>: Research, creation, and development of civil and military <strong>simulation software</strong>.',
      'Engines: <strong>Unity3D</strong> and proprietary military software.',
      '<strong>Supervisor</strong> of undergraduate and master\'s thesis projects.',
    ],
    technologies: ['Unity', 'C#', 'Simulation', 'Military Software'],
  },
  {
    id: '6dlab',
    role: 'CTO',
    company: '6DLab',
    type: 'work',
    startDate: '2019',
    endDate: '2019',
    description: [
      '<strong>Director Técnico</strong> y gestor de proyectos de un equipo de desarrolladores/artistas <strong>AR-VR</strong>.',
      'Gestión de proyectos de <strong>realidad aumentada y virtual</strong>.',
    ],
    descriptionEn: [
      '<strong>Technical Director</strong> and project manager of an <strong>AR-VR</strong> developers/artists team.',
      '<strong>Augmented and virtual reality</strong> project management.',
    ],
    technologies: ['Unity', 'AR/VR', 'C#', 'Team Management'],
  },
  {
    id: 'ludusvr',
    role: 'VR Program Developer, (AR-VR) Researcher and Developer',
    company: 'LudusVR',
    type: 'work',
    startDate: '2017',
    endDate: '2019',
    description: [
      'Desarrollador de programas <strong>AR-VR</strong>.',
      'Desarrollo de aplicaciones <strong>VR para Industria 4.0</strong>.',
      '<strong>Investigación y desarrollo</strong> en tecnologías <strong>XR</strong> emergentes.',
    ],
    descriptionEn: [
      '<strong>AR-VR</strong> program developer.',
      '<strong>VR applications for Industry 4.0</strong> development.',
      '<strong>Research and development</strong> in emerging <strong>XR</strong> technologies.',
    ],
    technologies: ['Unity', 'VR', 'AR', 'C#', 'Industry 4.0'],
  },
];

export const education: Education[] = [
  {
    id: 'master-ia-lidr',
    title: 'AI4Devs - Máster en IA para Desarrolladores',
    titleEn: 'AI4Devs - Master in AI for Developers',
    institution: 'LIDR',
    startDate: '2024',
    endDate: '2025',
    description: 'Especialización en desarrollo de software con Inteligencia Artificial.',
    descriptionEn: 'Specialization in software development with Artificial Intelligence.',
  },
  {
    id: 'grado-ingenieria',
    title: 'Grado en Ingeniería de Computadores',
    titleEn: 'Bachelor\'s Degree in Computer Engineering',
    institution: 'Universidad de Alcalá de Henares',
    startDate: '2013',
    endDate: '2017',
  },
  {
    id: 'unity-uah',
    title: 'Videogames Development with Unity3D Course',
    institution: 'Universidad de Alcalá de Henares',
    startDate: '2015',
    endDate: '2015',
  },
  {
    id: 'android-uah',
    title: 'Android Apps Development Course',
    institution: 'Universidad de Alcalá de Henares',
    startDate: '2012',
    endDate: '2012',
  },
  {
    id: 'unity-urjc',
    title: 'Videogames Development with Unity3D Course',
    institution: 'Universidad Rey Juan Carlos',
    startDate: '2011',
    endDate: '2011',
  },
  {
    id: 'blender-urjc',
    title: 'Blender 3D & Yafaray Course',
    institution: 'Universidad Rey Juan Carlos',
    startDate: '2011',
    endDate: '2011',
  },
];

export const skills = [
  // Core Unity
  { name: 'Unity', level: 100, category: 'core' },
  { name: 'C#', level: 100, category: 'core' },
  { name: 'Unity Custom Editor', level: 100, category: 'core' },

  // Full Stack Web
  { name: 'React', level: 90, category: 'web' },
  { name: 'TypeScript', level: 90, category: 'web' },
  { name: 'JavaScript', level: 85, category: 'web' },
  { name: 'Supabase', level: 85, category: 'web' },
  { name: 'Netlify', level: 80, category: 'web' },

  // AI & Development Tools
  { name: 'Claude Code', level: 95, category: 'ai' },
  { name: 'Cursor AI', level: 95, category: 'ai' },
  { name: 'AI Agents Development', level: 85, category: 'ai' },

  // Development Tools
  { name: 'Rider', level: 100, category: 'tools' },
  { name: 'Git', level: 100, category: 'tools' },
  { name: 'Plastic SCM', level: 100, category: 'tools' },

  // XR Technologies
  { name: 'AR/VR Development', level: 95, category: 'xr' },
  { name: 'HoloLens 2 / MRTK', level: 90, category: 'xr' },
  { name: 'ARFoundation', level: 95, category: 'xr' },
  { name: 'XR Interaction Toolkit', level: 90, category: 'xr' },

  // 3D & Rendering
  { name: '3ds Max', level: 80, category: '3d' },
  { name: 'V-Ray', level: 75, category: '3d' },
  { name: 'Unity WebGL', level: 95, category: '3d' },

  // Other
  { name: 'Networking/Multiplayer', level: 85, category: 'other' },
  { name: 'Computer Vision', level: 80, category: 'other' },
  { name: 'PHP', level: 75, category: 'other' },
  { name: 'Databases', level: 85, category: 'other' },
];

export const services = [
  {
    id: 'cto-leadership',
    title: 'CTO & Tech Leadership',
    description: 'Liderazgo técnico y consultoría estratégica para startups y empresas tecnológicas.',
    icon: 'leadership',
  },
  {
    id: 'fullstack-web',
    title: 'Desarrollo Full Stack',
    description: 'Aplicaciones web modernas con React, TypeScript, Supabase y arquitectura escalable.',
    icon: 'web',
  },
  {
    id: '3d-configurators',
    title: 'Configuradores 3D',
    description: 'Configuradores interactivos WebGL y soluciones de visualización hiperrealista.',
    icon: '3d',
  },
  {
    id: 'vr-ar-dev',
    title: 'Desarrollo XR (AR/VR/MR)',
    description: 'Experiencias inmersivas de realidad extendida para múltiples plataformas.',
    icon: 'vr',
  },
  {
    id: 'ai-integration',
    title: 'Integración de IA',
    description: 'Agentes inteligentes, automatización con IA y desarrollo asistido por IA.',
    icon: 'ai',
  },
  {
    id: 'serious-games',
    title: 'Serious Games',
    description: 'Videojuegos con propósito educativo o empresarial.',
    icon: 'game',
  },
  {
    id: 'architecture',
    title: 'Arquitectura de Software',
    description: 'Diseño de sistemas escalables, mantenibles y de alto rendimiento.',
    icon: 'architecture',
  },
  {
    id: 'mobile-dev',
    title: 'iOS/Android',
    description: 'Desarrollo de aplicaciones móviles nativas y cross-platform.',
    icon: 'mobile',
  },
];
